module.exports = __webpack_public_path__ + "static/media/time.a830398e.png";